import React, { useState } from 'react';
import SectionHeader from '../components/SectionHeader';
import { sampleProducts } from '../data/products';

// ===== CATEGORIES ADMIN =====
export function AdminCategories() {
  const [categories, setCategories] = useState([
    { id: 1, name: 'History', displayOrder: 1 },
    { id: 2, name: 'SciFi', displayOrder: 2 },
    { id: 3, name: 'Fiction', displayOrder: 3 },
    { id: 4, name: 'Children', displayOrder: 4 },
  ]);
  const [form, setForm] = useState({ name: '', displayOrder: '' });
  const [editing, setEditing] = useState(null);
  const [showForm, setShowForm] = useState(false);

  const handleSave = () => {
    if (!form.name.trim()) return;
    if (editing !== null) {
      setCategories(cats => cats.map(c => c.id === editing ? { ...c, ...form, displayOrder: parseInt(form.displayOrder) } : c));
      setEditing(null);
    } else {
      setCategories(cats => [...cats, { id: Date.now(), name: form.name, displayOrder: parseInt(form.displayOrder) || cats.length + 1 }]);
    }
    setForm({ name: '', displayOrder: '' });
    setShowForm(false);
  };

  const handleEdit = (cat) => {
    setEditing(cat.id);
    setForm({ name: cat.name, displayOrder: cat.displayOrder });
    setShowForm(true);
  };

  const handleDelete = (id) => {
    if (window.confirm('Delete this category?')) setCategories(cats => cats.filter(c => c.id !== id));
  };

  return (
    <div className="page-wrapper">
      <div className="container">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
          <SectionHeader title="Category Management" />
          <button className="btn btn-primary" onClick={() => { setShowForm(true); setEditing(null); setForm({ name: '', displayOrder: '' }); }} style={{ height: 40 }}>
            + New Category
          </button>
        </div>

        {showForm && (
          <div className="card" style={{ marginBottom: '1.5rem' }}>
            <div className="card-header"><h4>{editing ? 'Edit Category' : 'New Category'}</h4></div>
            <div className="card-body">
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1rem' }}>
                <div className="form-group">
                  <label className="form-label">Category Name</label>
                  <input className="form-control" value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} placeholder="Category name" />
                </div>
                <div className="form-group">
                  <label className="form-label">Display Order</label>
                  <input className="form-control" type="number" value={form.displayOrder} onChange={e => setForm(f => ({ ...f, displayOrder: e.target.value }))} placeholder="1" />
                </div>
              </div>
              <button className="btn btn-primary" onClick={handleSave}>Save</button>
              <button className="btn btn-outline-primary" onClick={() => setShowForm(false)} style={{ marginLeft: '0.5rem' }}>Cancel</button>
            </div>
          </div>
        )}

        <div className="card">
          <div className="card-body" style={{ padding: 0 }}>
            <table className="admin-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Display Order</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {categories.sort((a, b) => a.displayOrder - b.displayOrder).map((cat, i) => (
                  <tr key={cat.id}>
                    <td>{i + 1}</td>
                    <td>{cat.name}</td>
                    <td>{cat.displayOrder}</td>
                    <td>
                      <button className="btn btn-outline-primary btn-sm" onClick={() => handleEdit(cat)} style={{ marginRight: 6 }}>Edit</button>
                      <button className="btn btn-sm" style={{ background: 'var(--danger)', color: 'white', border: 'none', borderRadius: 4, padding: '0.25rem 0.6rem', cursor: 'pointer', fontSize: '0.8rem' }} onClick={() => handleDelete(cat.id)}>Delete</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

// ===== PRODUCTS ADMIN =====
export function AdminProducts() {
  return (
    <div className="page-wrapper">
      <div className="container">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
          <SectionHeader title="Product Management" />
          <button className="btn btn-primary" style={{ height: 40 }}>+ New Product</button>
        </div>
        <div className="card">
          <div className="card-body" style={{ padding: 0 }}>
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Title</th>
                  <th>ISBN</th>
                  <th>Author</th>
                  <th>Category</th>
                  <th>List Price</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {sampleProducts.map(p => (
                  <tr key={p.id}>
                    <td><strong>{p.title}</strong></td>
                    <td style={{ fontSize: '0.85rem', color: 'var(--text-muted)' }}>{p.isbn}</td>
                    <td>{p.author}</td>
                    <td>{p.category.name}</td>
                    <td>${p.listPrice.toFixed(2)}</td>
                    <td>
                      <button className="btn btn-outline-primary btn-sm" style={{ marginRight: 6 }}>Edit</button>
                      <button className="btn btn-sm" style={{ background: 'var(--danger)', color: 'white', border: 'none', borderRadius: 4, padding: '0.25rem 0.6rem', cursor: 'pointer', fontSize: '0.8rem' }}>Delete</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

// ===== ORDERS ADMIN =====
export function AdminOrders() {
  const sampleOrders = [
    { id: 1, name: 'John Smith', email: 'john@example.com', phone: '555-1234', status: 'Pending', total: 180.00, date: '2024-01-15' },
    { id: 2, name: 'Jane Doe', email: 'jane@example.com', phone: '555-5678', status: 'Approved', total: 95.50, date: '2024-01-14' },
    { id: 3, name: 'Bob Johnson', email: 'bob@example.com', phone: '555-9012', status: 'Shipped', total: 340.00, date: '2024-01-13' },
  ];

  const statusColor = (s) => ({
    Pending: '#BD7418', Approved: 'var(--primary)', Shipped: 'var(--success)', Refunded: 'var(--danger)'
  }[s] || '#999');

  return (
    <div className="page-wrapper">
      <div className="container">
        <SectionHeader title="Order Management" />
        <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1rem', flexWrap: 'wrap' }}>
          {['All', 'Pending', 'Approved', 'In Process', 'Shipped', 'Cancelled', 'Refunded'].map(f => (
            <button key={f} className="btn btn-outline-primary btn-sm">{f}</button>
          ))}
        </div>
        <div className="card">
          <div className="card-body" style={{ padding: 0 }}>
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Order #</th>
                  <th>Customer</th>
                  <th>Phone</th>
                  <th>Status</th>
                  <th>Date</th>
                  <th>Total</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {sampleOrders.map(o => (
                  <tr key={o.id}>
                    <td>#{o.id}</td>
                    <td><strong>{o.name}</strong><br /><small style={{ color: 'var(--text-muted)' }}>{o.email}</small></td>
                    <td>{o.phone}</td>
                    <td><span style={{ color: statusColor(o.status), fontWeight: 700, fontSize: '0.85rem' }}>{o.status}</span></td>
                    <td style={{ fontSize: '0.9rem' }}>{o.date}</td>
                    <td><strong>${o.total.toFixed(2)}</strong></td>
                    <td><button className="btn btn-outline-primary btn-sm">Details</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

// ===== USERS ADMIN =====
export function AdminUsers() {
  const sampleUsers = [
    { id: 1, name: 'Admin User', email: 'admin@example.com', phone: '555-0001', company: 'Internal', role: 'Admin' },
    { id: 2, name: 'Company User', email: 'company@example.com', phone: '555-0002', company: 'Acme Corp', role: 'Company' },
    { id: 3, name: 'Regular User', email: 'user@example.com', phone: '555-0003', company: '', role: 'Customer' },
  ];

  return (
    <div className="page-wrapper">
      <div className="container">
        <SectionHeader title="User Management" />
        <div className="card">
          <div className="card-body" style={{ padding: 0 }}>
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Company</th>
                  <th>Role</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {sampleUsers.map(u => (
                  <tr key={u.id}>
                    <td><strong>{u.name}</strong></td>
                    <td>{u.email}</td>
                    <td>{u.phone}</td>
                    <td>{u.company || '—'}</td>
                    <td><span className="badge" style={{ background: u.role === 'Admin' ? 'var(--primary)' : 'rgba(189,116,24,0.6)' }}>{u.role}</span></td>
                    <td>
                      <button className="btn btn-outline-primary btn-sm" style={{ marginRight: 6 }}>Manage Role</button>
                      <button className="btn btn-sm" style={{ background: 'var(--danger)', color: 'white', border: 'none', borderRadius: 4, padding: '0.25rem 0.6rem', cursor: 'pointer', fontSize: '0.8rem' }}>Lock</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

// ===== COMPANIES ADMIN =====
export function AdminCompanies() {
  const sampleCompanies = [
    { id: 1, name: 'Acme Corp', streetAddress: '123 Main St', city: 'Portland', state: 'OR', postalCode: '97201', phone: '503-555-0001' },
    { id: 2, name: 'Tech Solutions', streetAddress: '456 Oak Ave', city: 'Seattle', state: 'WA', postalCode: '98101', phone: '206-555-0002' },
  ];

  return (
    <div className="page-wrapper">
      <div className="container">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
          <SectionHeader title="Company Management" />
          <button className="btn btn-primary" style={{ height: 40 }}>+ New Company</button>
        </div>
        <div className="card">
          <div className="card-body" style={{ padding: 0 }}>
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Address</th>
                  <th>City</th>
                  <th>State</th>
                  <th>Phone</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {sampleCompanies.map(c => (
                  <tr key={c.id}>
                    <td><strong>{c.name}</strong></td>
                    <td>{c.streetAddress}</td>
                    <td>{c.city}</td>
                    <td>{c.state} {c.postalCode}</td>
                    <td>{c.phone}</td>
                    <td>
                      <button className="btn btn-outline-primary btn-sm" style={{ marginRight: 6 }}>Edit</button>
                      <button className="btn btn-sm" style={{ background: 'var(--danger)', color: 'white', border: 'none', borderRadius: 4, padding: '0.25rem 0.6rem', cursor: 'pointer', fontSize: '0.8rem' }}>Delete</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
